module.exports = __webpack_public_path__ + "static/media/navy-pledge-2.6900fea5.png";